/* eslint-disable camelcase */
import './Moodboard.scss';
import { Container, Row, Col } from 'react-bootstrap';
import React from 'react';
import useBreakpoint from '../../hooks/useBreakpoint';
import PropTypes from 'prop-types';
import MoodboardMedia from './MoodboardMedia';



/**
 * @typedef MoodboardParams
 * @property {[string]} moodboardMedia
 * @property {number} rows
 *
 * @param {MoodboardParams} param
 * @returns
 */
const Moodboard = ({ moodboardMedia, rows }) => {

  const breakpoint = useBreakpoint();
  // Returns a row for a n number of images
  // This is used to iterate through the images urls object.
  // The only allowed cases for row sizes are 2, 3 and 4
  // that is a constrain from the product team.
  const randomRowBySizeCase = (n) => {
    switch (n) {
      case 2:
        return [2];
      case 3:
        return [3];
      case 4:
        return [4];
      case 5:
        return randomRowFromSize5();
      default:
        // After setting the case for a allowed size
        // it goes to the next remaining number of images
        return randomFinalArrangement(n);
    }
  };

  // Case when there are only 4 images
  // This case is different than when iterating
  // because there are 2 possible combinatios if there are
  // only 4 images, but when iterating and the random number
  // is 4 that means the row should have 4 images, and that
  // case is defined in the randomBySizeCase function.
  const randomRowFromOnly4 = () => {
    let i = Math.floor(Math.random() * 2);
    let options = [[2, 2], [4]];
    return options[i];
  };

  // Case when there are 5 images
  // This function is intended to be used in both
  // cases, when there are only 5 images and
  // when the remaining images size is 5 when iterating,
  // so it should pick randomly one of the 2 allowed cases.
  const randomRowFromSize5 = () => {
    let i = Math.floor(Math.random() * 2);
    let options = [[2, 3], [3, 2]];
    return options[i];
  };

  // The input method to get the final arrangement
  // from the initial set of images urls
  const randomFinalArrangement = (m) => {
    let i = Math.floor(Math.random() * 3);
    // opts are the only valid row sizes for the moddborad rows
    // Base cases 4,5 are different that when looping with more than 6 images.
    if (m == 4) {
      return randomRowFromOnly4();
    }
    if (m == 5) {
      return randomRowFromSize5();
    }
    let opts = [2, 3, 4];
    let random = opts[i];
    let result = [random];
    let rest = m - random;

    while (rest > 0) {
      if (rest == 5) {
        let pair = randomRowFromSize5();
        rest = 0;
        result = result.concat(pair);
      }
      else {
        let toAdd = randomRowBySizeCase(rest);
        rest = rest - toAdd.reduce((a, b) => a + b);
        result = result.concat(toAdd);
      }
    }
    return result;
  };

  let arrangement = randomFinalArrangement((moodboardMedia && moodboardMedia.length));
  let images = [...(moodboardMedia || [])];

  return (<Container className="moodboard" key='moodboard-container'>
    {arrangement
      .slice(0, rows || arrangement.length)
      .map((rowSize, rowIdx) => (
        <Row key={`row-${rowIdx}`}>
          {images.splice(0, rowSize).map((imgUrl, imgIdx) =>
            <Col key={`col-${rowIdx}-${imgIdx}`}
              xs={breakpoint == 'xs' && 12}>
              <MoodboardMedia key={`img-${rowIdx}-${imgIdx}`}
                url={imgUrl}
                className='moodboard-img-mid-size' />
            </Col>)}
        </Row>
      ))}
  </Container>);
};

Moodboard.propTypes = {
  moodboardMedia: PropTypes.arrayOf(PropTypes.string),
  rows: PropTypes.number,
};

Moodboard.defaultProps = {
  moodboardMedia: [],
};

export default React.memo(Moodboard);
